import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import ToggleInfoBox$1 from './ToggleInfoBox.js';

const getAccessibleLabel = (text, checked, toggleIsOn, toggleIsOff)=>`${text} ${checked ? toggleIsOn : toggleIsOff}`
;
const ToggleInfoBoxContainer = (_param)=>{
    var { text , checked , onChange  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "text",
        "checked",
        "onChange"
    ]);
    const { getLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            toggleIsOn: getLabel('elements.toggleInfoBox.toggleIsOn'),
            toggleIsOff: getLabel('elements.toggleInfoBox.toggleIsOff')
        })
    , [
        getLabel
    ]);
    const [accessibleLabelText, setAccessibleLabel] = React.useState(getAccessibleLabel(text, checked, labels.toggleIsOn, labels.toggleIsOff));
    const handleOnChange = React.useCallback((isChecked)=>{
        onChange(isChecked);
        setAccessibleLabel(getAccessibleLabel(text, isChecked, labels.toggleIsOn, labels.toggleIsOff));
    }, [
        text,
        labels,
        onChange
    ]);
    return /*#__PURE__*/ React.createElement(ToggleInfoBox$1, swcHelpers.extends({}, rest, {
        text: text,
        checked: checked,
        onChange: handleOnChange,
        accessibleLabelText: accessibleLabelText
    }));
};
var ToggleInfoBox = ToggleInfoBoxContainer;

export { ToggleInfoBox as default };
//# sourceMappingURL=ToggleInfoBoxContainer.js.map
